module.exports = __webpack_public_path__ + "media/images/map/rides-map-img-c68c84e445b56bb8abf88c59351ebaf8.png";